import React from 'react';
import { OneLineInput } from '../⚛️atoms/OneLineInput';
import { TiptapEditor } from '../⚛️atoms/TiptapEditor';
import { MarkdownWrapper } from './MarkdownWrapper';
import useLockedTranslate from '../../Hooks/useLockedTranslate';
import { getTranslation, updateTranslation } from '../../utils/translationHelper';
import { useWorkbookV2EditorGridResize } from '../../Hooks/useWorkbookV2EditorGridResize';
import { TranslateButton } from '../atoms/translateButton';
import { cloneWorkbookV2Value } from './editorUtils';

export const WorkbookV2Quote = ({ item, updateItem, editing, editingLanguage = null, workbook }) => {
  const { lang } = useLockedTranslate(workbook);
  const { editGrid, gridCols } = useWorkbookV2EditorGridResize();

  const updateEditorItem = (updates) => {
    const nextItem = cloneWorkbookV2Value(item);
    nextItem.text = updates.text ?? nextItem.text;
    nextItem.page_number = updates.page_number ?? nextItem.page_number;
    nextItem.translations = updates.translations ?? nextItem.translations;
    nextItem.options = {
      ...(nextItem.options ?? {}),
      ...(updates.options ?? {})
    };
    updateItem(nextItem);
  };

  return (
    <div className={`flex w-full items-center gap-2 ${editing && 'border-pdteal rounded-lg border-2 px-8 py-12'}`}>
      {!editing && (
        <div className="from-pdteal/10 to-pddarkblue/5 mb-5 w-9/10 overflow-hidden rounded-2xl border-1 border-gray-200 bg-linear-150 p-4 shadow-lg backdrop-blur-2xl">
          <span className="text-pdyellow float-left h-20 self-start pr-8 text-[10rem]/[100%] font-bold italic">“</span>
          <p className="text-2xl italic">
            <MarkdownWrapper>{lang === 'en' ? item.text : getTranslation(item.translations, lang, 'text', item.text)}</MarkdownWrapper>
          </p>
          {item.options?.attribution && (
            <div className="text-pddarkblue/90 float-right clear-both mt-8 mr-8 text-2xl font-semibold italic">
              – {item.options.attribution}
            </div>
          )}
        </div>
      )}
      {editing && (
        <div className={`grid w-full gap-8 ${gridCols} transition-all duration-300 ease-out`} ref={editGrid}>
          <div className="relative">
            <p className="mb-2 text-xl/6 font-medium text-gray-900">Quote</p>
            <TiptapEditor content={item.text} onChange={(value) => updateEditorItem({ text: value })} />
            {editingLanguage && (
              <TranslateButton
                text={item.text}
                language={editingLanguage}
                onResponse={(value) =>
                  updateEditorItem({
                    translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                  })
                }
              />
            )}
          </div>
          {editingLanguage && (
            <div>
              <p className="mb-2 text-xl/6 font-medium text-gray-900">Quote ({editingLanguage})</p>
              <TiptapEditor
                content={getTranslation(item.translations, editingLanguage, 'text')}
                onChange={(value) =>
                  updateEditorItem({
                    translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                  })
                }
              />
            </div>
          )}
          <div className="w-2/5">
            <OneLineInput
              value={item.page_number}
              label="Page Number"
              onChange={(value) => updateEditorItem({ page_number: value })}
            />
          </div>
          <div className="w-3/4">
            <OneLineInput
              value={item.options?.attribution}
              onChange={(value) => updateEditorItem({ options: { attribution: value } })}
              label="Attribution"
            />
          </div>
        </div>
      )}
    </div>
  );
};
